import { render } from "./pos-header.vue?vue&type=template&id=4f948154&scoped=true"
import script from "./pos-header.vue?vue&type=script&lang=js"
export * from "./pos-header.vue?vue&type=script&lang=js"

import "./pos-header.vue?vue&type=style&index=0&id=4f948154&scoped=true&lang=css"
import "./pos-header.vue?vue&type=style&index=1&id=4f948154&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f948154"]])

export default __exports__